import React from 'react';
import * as moment from "moment-timezone";
import * as PropTypes from "prop-types";

const DateTimeDisplay = ({ date, format, ...props }) => {
  let str;
  if (!date) {
    str = 'None';
  } else if (typeof(date) === "string") {
    str = date;
  } else {
    str = moment(date).tz(moment.tz.guess()).format(format || 'MM/DD/YYYY h:mm A z');
  }
  return (
    <span {...props}>
      {str}
    </span>
  );
};

DateTimeDisplay.propTypes = {
  date: PropTypes.any,
};

export default React.memo(DateTimeDisplay);



// WEBPACK FOOTER //
// ./src/components/Boilerplate/DateTimeDisplay.js